import React from 'react';
import { connect } from 'react-redux';
import * as images from 'shared/images';
import { agencyLandingPageUrl } from 'shared/config';

class AgencyBanner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    // display link to agency landing page if user searches for agency
    const landing_page_desc =
      'View the latest Regulatory Agenda activity, recent news, and visual insights for the';
    const agency_id_info_map = {
      573: landing_page_desc + ' Consumer Financial Protection Bureau.',
      194: landing_page_desc + ' Financial Crimes Enforcement Network.',
      466: landing_page_desc + ' Securities and Exchange Commission.',
      188: landing_page_desc + ' Federal Reserve System.',
      164: landing_page_desc + ' Federal Deposit Insurance Corporation.',
      80: landing_page_desc + ' Comptroller of the Currency.',
      192: landing_page_desc + ' Federal Trade Commission.'
    };

    const selected_agency_id = this.props.filtered_mention.mention.id;
    const bag_of_words = this.props.current_view.search_params.search_query;
    const list_items = [];
    if (agency_id_info_map[selected_agency_id] && !bag_of_words) {
      list_items.push(
        <li className="blue-color document-result">
          <a
            className="link-to-agency-page"
            href={agencyLandingPageUrl + '?blur=false&id=' + selected_agency_id}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="document-result-content">
              <div className="document-result-row header">
                <div className="document-result-title">
                  {'Agency Landing Page: ' + this.props.filtered_mention.mention.short_name}
                  <div className="document-result-summary-text">
                    {agency_id_info_map[selected_agency_id]}
                  </div>
                </div>
                <div className="chart-img-container">
                  <img src={images.misc.yearOnAgendaChart} alt="img-container" />
                </div>
                <div className="chart-img-container">
                  <img src={images.misc.consumerCompliantsChart} alt="img-container" />
                </div>
              </div>
            </div>
          </a>
        </li>
      );
    }

    return (
      <div className="document-search-list-container">
        <ul className="document-search-list">{list_items}</ul>
      </div>
    );
  }
}

const mapStateToProps = ({ filtered_mention, current_view }) => {
  return {
    filtered_mention,
    current_view
  };
};

const ReduxAgencyBanner = connect(mapStateToProps)(AgencyBanner);

export default ReduxAgencyBanner;
